<template lang="pug">
  v-navigation-drawer(
    :value="value"
    width="100%"
    app
    absolute
    floating
    class="drawer-mobile-navigation-menu"
    :color="$vuetify.theme.currentTheme.drawer"
  )
    block-profile-menu-content(
      :show-about-us="false"
      class="drawer-mobile-content-offset"
      @closeDrawer="$emit('closeDrawer')"
    )
</template>

<script>
import ESvgIcon from '~/components/elements/icons/e-svg-icon'
import BlockProfileMenuContent from '~/modules/profile/components/block-profile-menu-content'

export default {
  name: 'DrawerMobile',
  components: {
    BlockProfileMenuContent,
    ESvgIcon
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.drawer-mobile-navigation-menu {
  z-index: map-get($zIndexes, 'modal');
}
.drawer-mobile-content-offset {
  padding-top: 56px;
  /* Ensure content isn't hidden behind iOS/Android browser bottom bars */
  padding-bottom: calc(56px + env(safe-area-inset-bottom));
}

/* Make the drawer account for safe area at the bottom as well */
.drawer-mobile-navigation-menu {
  z-index: map-get($zIndexes, 'modal');
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
